import _extends from "/data/wwwroot/dongliyuanlin.com/web/node_modules/babel-runtime/helpers/extends";
import _regeneratorRuntime from "/data/wwwroot/dongliyuanlin.com/web/node_modules/babel-runtime/regenerator";
import _asyncToGenerator from "/data/wwwroot/dongliyuanlin.com/web/node_modules/babel-runtime/helpers/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CommonContent from "~/components/CommonContent";
import PageTitle from "~/components/PageTitle";

import { mapState } from "vuex";
export default {
  components: {
    CommonContent: CommonContent,
    PageTitle: PageTitle
  },
  asyncData: function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
      var params = _ref.params,
          store = _ref.store,
          query = _ref.query;
      var result;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return store.dispatch("getPageDetail", { id: params.id, lang: query.lang });

            case 2:
              result = _context.sent;
              return _context.abrupt("return", { pageData: result });

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function asyncData(_x) {
      return _ref2.apply(this, arguments);
    }

    return asyncData;
  }(),

  computed: _extends({}, mapState(["winHeight", 'lang']), {
    up: function up() {
      return {
        height: this.winHeight - 60 + "px"
      };
    },
    pro: function pro() {
      if (this.lang === 'en') {
        return 'News';
      } else {
        return '新  闻';
      }
    },
    contents: function contents() {
      var reg = /src="/g;
      if (this.lang === 'en') {
        return this.pageData.content.replace(reg, 'src="http://adminen.dongliyuanlin.com');
      } else {
        return this.pageData.content.replace(reg, 'src="http://admin.dongliyuanlin.com');
      }
    }
  }),
  mounted: function mounted() {
    // console.log(document)
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/data/wwwroot/dongliyuanlin.com/web/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/news/_id.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/data/wwwroot/dongliyuanlin.com/web/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/news/_id.vue
// module chunks = 11